/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import ictLogo from '../../assets/images/ICT-Logo-V4-1-1 1 (1).png';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
// import AddEditUser from './AddEditUser';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './FitnessCertificateRenewalManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import { useNavigate } from 'react-router-dom';
import { handlePostRequest } from '../../services/PostTemplate';
import SuccessLoader from '../../components/SuccessLoader';
import RenewFitnessCertificate from './RenewFitnessCertificate';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';

const RenewFitnessCertificateManagement = () => {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [roleIDOptions, setroleIDOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const dispatch = useDispatch();
    const menuRefs = useRef(new Map());
    const [renewDialogVisible, setRenewDialogVisible] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(''); 
    const [searchFilters, setSearchFilters] = useState({
        vehicleNumber: null,
        cfxNumber: null,
        vehicleTypeId: 0,
        startDate: null,
        endDate: null,
        vehicleTypeId: null,
        paymentMethodId: null
    });
    const [vehicleList, setVehicleList] = useState();
    const [methodList, setMethodList] = useState();
    const [statusList, setStatusList] = useState();

    const navigate = useNavigate();

    const handleDelete = async (row) => {
        setShowSuccess(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/User/Delete?id=${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                fetchFitnessCertificateManagement(page);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setShowSuccess(false);
        }
    };

    const fetchFitnessCertificateManagement = async (pageNumber = 1) => {
        setLoading(true);
        try {
               const formatDate = (date) => {
                if (!date) return null;
                if (typeof date === 'string') return date;
                return date instanceof Date ? 
                    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : 
                    null;
            };
             const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
const DEFAULT_START_DATE = "2020-02-01";

   let startDate = searchFilters.startDate ? formatDate(searchFilters.startDate) : DEFAULT_START_DATE;
            let endDate = searchFilters.endDate ? formatDate(searchFilters.endDate) : currentDate;
              const requestBody = {
                  pageNumber: pageNumber,
                  pageSize: rows,
                  vehicleNumber: searchFilters?.vehicleNumber,
                  vehicleTypeId: searchFilters?.vehicleTypeId,
                  cfxNumber: searchFilters?.cfxNumber,
                  startDate: startDate,
                  endDate: endDate,
                  paymentMethodId: searchFilters?.paymentMethodId
              };

            const response = await dispatch(
                handlePostRequest(
                    requestBody, 
                    '/api/fitness/expire', 
                    false, 
                    false  
                )
            );

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            }
            else {
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching fitness certificate data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchFitnessCertificateManagement(newPage);
    };

    useEffect(() => {
        fetchFitnessCertificateManagement(page);
    }, []);

    const handleRenew = (row) => {
        setSelectedCertificate(row);
        setSidebarVisible(true);
    };
    const actionBodyTemplate = (rowData) => {
        return <Button icon="pi pi-refresh" className="p-button-xl p-button-rounded p-button-text p-button-info" onClick={() => handleRenew(rowData)} tooltip="Renew" tooltipOptions={{ position: 'top' }} />;
    };

    const rowClassName = (rowData) => {
        return 'dataTableRow';
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const onHideSidebar = () => {
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

    const getRoleID = async () => {

        const response = await handleGetRequest('/api/role');
        if (response?.success) {
            const formattedOptions = response.data.map((role) => ({
                label: role.name,
                value: role.id
            }));
            setroleIDOptions(formattedOptions);
        } else {
            console.error('Failed to fetch roles:', response?.message);
        }
    };

    useEffect(() => {
        getRoleID();
    }, []);

    const handleSearchFilterChange = (field, value) => {
        setSearchFilters((prev) => ({
            ...prev,
            [field]: value
        }));
    };
    const handleSearch = () => {
        setPage(1);
        setFirst(0);
        fetchFitnessCertificateManagement(1);
    };

    const handleClearSearch = () => {
        setSearchFilters({
            vehicleNumber: null,
            cfxNumber: null,
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            vehicleTypeId: null,
            paymentMethodId: null,
            
        });
        setPage(1);
        setFirst(0);
        fetchFitnessCertificateManagement(1);
    };

    const getLovsData = async () => {
        const vehiclesData = await handleGetRequest('/api/fitness/fee', false);
        if (vehiclesData?.success) {
            setVehicleList(vehiclesData?.data);
        }
        const methodsData = await handleGetRequest('/api/dropdown/payment/method', false);
        if (methodsData?.success) {
            setMethodList(methodsData?.data);
        }
        const statusData = await handleGetRequest('/api/dropdown/request/status', false);
        if (statusData?.success) {
            setStatusList(statusData?.data);
        }
    };

    useEffect(() => {
        getLovsData();
    }, []);

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="On clicking this, user details will be removed from the system. Proceed further?"
                contentClassName="content-className"
                header="Delete User"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    {sidebarVisible && selectedCertificate && (
                        <Sidebar
                            className="p-sidebar-md"
                            visible={sidebarVisible}
                            position="right"
                            onHide={onHideSidebar}
                            style={{ width: '30rem' }}
                            pt={{
                                header: { className: 'border-bottom-1' },
                                content: { className: 'p-0', style: { overflow: 'hidden' } }
                            }}
                            showCloseIcon={false}
                        >
                            <RenewFitnessCertificate onHideSidebar={onHideSidebar} rowData={selectedCertificate} fetchCertificatesData={fetchFitnessCertificateManagement} />
                        </Sidebar>
                    )}
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Fitness Renewal Management</h2>
                        {/* <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                        </span> */}
                    </div>
                    <div className="mt-3 p-3 border-1 surface-border border-round">
                        <div className="grid">
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                
                                    <InputText id="vehicleNumber" value={searchFilters.vehicleNumber || null} onChange={(e) => handleSearchFilterChange('vehicleNumber', e.target.value)} placeholder="Enter vehicle number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                
                                    <InputText id="cfxNumber" value={searchFilters.cfxNumber || null} onChange={(e) => handleSearchFilterChange('cfxNumber', e.target.value)} placeholder="Enter CFX number" className="Input__Round" />
                                </span>
                            </div>
                           
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={vehicleList}
                                        optionValue="id"
                                        optionLabel="categoryName"
                                        id="vehicleTypeId"
                                        name="vehicleTypeId"
                                        value={searchFilters.vehicleTypeId}
                                        onChange={(e) => handleSearchFilterChange('vehicleTypeId', e.target.value)}
                                        placeholder="Select Vehicle Category"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={methodList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="paymentMethodId"
                                        value={searchFilters.paymentMethodId}
                                        onChange={(e) => handleSearchFilterChange('paymentMethodId', e.target.value)}
                                        placeholder="Select Payment Method"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                           
                            <div className="col-12 md:col-3">
                                 <Calendar
                                                                    id="startDate"
                                                                    name="startDate"
                                                                    placeholder="Select start date"
                                                                    dateFormat="mm/dd/yy"
                                                                    value={searchFilters.startDate}
                                                                    onChange={(e) => handleSearchFilterChange('startDate', e.value)}
                                                                    inputClassName="Input__Round"
                                                                />
                            </div>
                            <div className="col-12 md:col-3">
                               <Calendar id="endDate" name="endDate" placeholder="Select end date" dateFormat="mm/dd/yy" value={searchFilters.endDate} onChange={(e) => handleSearchFilterChange('endDate', e.value)} inputClassName="Input__Round" />
                            </div>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-3">
                            <Button label="Search" icon="pi pi-search" className="px-4 py-2 font-semibold" style={{ backgroundColor: '#ff556a', border: 'none', borderRadius: '10px' }} onClick={handleSearch} />
                            <Button label="Clear" icon="pi pi-times" className="px-4 py-2 font-semibold" style={{ borderRadius: '10px', backgroundColor: '#ff556a', border: 'none' }} onClick={handleClearSearch} />
                        </div>
                    </div>
                    <div className="card mt-3">
                        <DataTable value={tableData} loading={loading} responsiveLayout="scroll" className="datatable-responsive shadow-md rounded-xl" scrollable scrollHeight="45vh" stickyHeader emptyMessage={
        <div className="w-full text-center">
            No results found
        </div>
                               }>
                            <Column field="vehicleNo" header="Vehicle Number" />
                            <Column field="vehicleType" header="Vehicle Category" />
                            <Column field="cfxNo" header="CFX number" />
                            <Column field="issueDate" header="Issue Date" />
                            <Column field="expDate" header="Expiry Date" />
                            <Column header="Renew" body={(rowData) => actionBodyTemplate(rowData)} />
                        </DataTable>
                        <div className="flex justify-content-between mt-1" style={{ borderTop: '1px solid #efefef' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RenewFitnessCertificateManagement;
